// eslint-disable-next-line import/no-unresolved
import visit from 'unist-util-visit'

import { VisitNode } from './types'

import type { Parent, Data } from 'unist'

type LiteralVisitNode = VisitNode & {
    children?: LiteralVisitNode[]
    depth?: number
}

const moveChildrenToParent = (node: LiteralVisitNode, index: number, parent: Parent<VisitNode, Data> | undefined) => {
    if (parent?.children && node.children) {
        // moves the children to the parent
        parent.children.splice(index, 1, ...node.children)
    }
}

const removeChildrenFromParent = (node: VisitNode, index: number, parent: Parent<VisitNode, Data> | undefined) => {
    if (parent?.children) {
        // simply removes the image from parent
        parent.children.splice(index, 1)
    }
}

type Features = 'bold' | 'italic' | 'link' | 'image'

const TypeMap: Record<
    Features,
    {
        types: string[]
        ignore: (node: LiteralVisitNode, index: number, parent: Parent<VisitNode, Data> | undefined) => void
    }
> = {
    bold: {
        types: ['strong'],
        ignore: moveChildrenToParent,
    },
    italic: {
        types: ['emphasis'],
        ignore: moveChildrenToParent,
    },
    link: {
        types: ['link'],
        ignore: moveChildrenToParent,
    },
    image: {
        types: ['image'],
        ignore: removeChildrenFromParent,
    },
}

export type AllowableFeatures = Partial<Record<Features, boolean | undefined>>

type DisableTokensPluginProps = {
    allow?: AllowableFeatures
    maxHeadingDepth?: number
}

export const disableTokens = (options: DisableTokensPluginProps) => {
    const { allow, maxHeadingDepth } = options

    if ((!allow || !Object.keys(allow).length) && !maxHeadingDepth) {
        return () => {}
    }

    return (tree: VisitNode) => {
        visit(tree, (node: LiteralVisitNode, index: number, parent: Parent<VisitNode, Data> | undefined) => {
            const keys = Object.keys(TypeMap) as Array<Features>

            if (node.type === 'heading' && maxHeadingDepth && node.depth && node.depth < maxHeadingDepth) {
                node.depth = maxHeadingDepth
            }

            const type = keys.find((key) => TypeMap[key].types.includes(node.type))
            if (type && allow && !allow[type]) {
                TypeMap[type].ignore(node, index, parent)
            }
        })
    }
}
